<template>
  <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-min-h-20">
    <p class="tw-max-w-[700px] tw-text-[24px]">
      {{ message }}
    </p>
    <div class="tw-flex tw-flex-row tw-items-center tw-m-5">
      <b-avatar
        variant="primary"
        size="50px"
        class="tw-mr-3"
        :src="url"
      />
      <div
        v-if="loading"
        class="tw-flex tw-flex-col"
      >
        <BSkeleton
          v-for="i in 2"
          :key="i"
          class="tw-inline tw-gap-4 tw-w-[150px]"
        />
      </div>
      <div v-else>
        <span>{{ doctorName }}</span>
        <br>
        <span>Winona Physician</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    doctorName: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '@/assets/images/svg/discount.svg',
    },
    message: {
      type: String,
      default: 'Your review has been sent to the doctor.',
    },
  }
}
</script>
